@if (isloaderVisible$ | async) {
  <div class="overlay">
    <div class="loader-content">
      <div class="loader-spinner" aria-hidden="true"></div>
      <p class="loader-text">{{ (loaderText$ | async) || 'Loading...' }}</p>
    </div>
  </div>
}
